import {
  hasActionPermission,
  hasAdminConsoleAccess,
  hasMenuPermission,
} from '@/constants/adminAuth';

/**
 * Umi Access 插件导出：把 currentUser 的 menuCodes/actionCodes 暴露为 hasMenu、hasAction。
 *
 * 权限判定逻辑在 constants/adminAuth.ts；路由与按钮分别配合 routes.menuCode、ActionGuard。
 *
 * @see https://umijs.org/docs/max/access#access
 */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};

  return {
    hasAdminConsoleAccess: hasAdminConsoleAccess(currentUser),
    hasMenu: (code: string) => hasMenuPermission(currentUser, code),
    hasAction: (code: string) => hasActionPermission(currentUser, code),
    canAdmin: hasAdminConsoleAccess(currentUser),
  };
}
